import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = {
  class: "modal fade",
  id: "servicePointModal",
  tabindex: "-1",
  "aria-labelledby": "confirm",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  ref: "modalRef"
}
const _hoisted_3 = { class: "modal-dialog modal-fullscreen" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title me-5",
  id: "exampleModalLabel"
}, "Node", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: null }, "ทั้งหมด", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  class: "btn btn-primary me-3",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  type: "button"
}
const _hoisted_11 = { class: "modal-body" }
const _hoisted_12 = ["id", "data-id", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "ms-4 me-4 btn btn-link p-0",
      "data-bs-toggle": "modal",
      "data-bs-target": "#servicePointModal",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.saveBeforeChange && $setup.saveBeforeChange(...args)))
    }, " +Add "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedProvince) = $event)),
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleChangeProvince && $setup.handleChangeProvince(...args))),
                name: "province",
                "data-placeholder": "เลือกจังหวัด",
                class: "form-select form-select-sm form-select-solid"
              }, [
                _hoisted_8,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.provinces, (province) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: province.id,
                    value: province.id
                  }, _toDisplayString(province.name), 9, _hoisted_9))
                }), 128))
              ], 544), [
                [_vModelSelect, $setup.selectedProvince]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", _hoisted_10, " Save " + _toDisplayString($setup.selectedId?.length || 0) + " Store Selected ", 1),
              _createElementVNode("button", {
                class: "btn btn-danger",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.loadSavedSelectedId && $setup.loadSavedSelectedId(...args))),
                type: "button"
              }, " Cancel ")
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createTextVNode(_toDisplayString($setup.isServicePointsLoading) + " ", 1),
            _createVNode(_component_Datatable, {
              ref: "tableRef",
              "table-header": $setup.tableHeader,
              "table-data": $setup.tableData,
              loading: $setup.isServicePointsLoading,
              total: $setup.totalServicePoints
            }, _createSlots({
              "cell-no": _withCtx(({ index }) => [
                _createTextVNode(_toDisplayString(index +
                  1 +
                  _ctx.storeTableOption.rowsPerPage *
                    (_ctx.storeTableOption.currentPage - 1)), 1)
              ]),
              "cell-selectStore": _withCtx(({ row }) => [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: `checkbox${row.id}`,
                  "data-id": `${row.id}`,
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.handleSelected && $setup.handleSelected(...args))),
                  checked: $setup.selectedId.includes(row.id)
                }, null, 40, _hoisted_12)
              ]),
              "cell-provinceName": _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.province?.name || '-'), 1)
              ]),
              _: 2
            }, [
              _renderList($setup.tableHeader.filter(
                  (data) => !['selectStore', 'provinceName'].includes(data.key)
                ), (item, i) => {
                return {
                  name: `cell-${item.key}`,
                  fn: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(row[`${item.key}`]), 1)
                  ])
                }
              })
            ]), 1032, ["table-header", "table-data", "loading", "total"])
          ])
        ])
      ])
    ], 512)
  ]))
}